import React, { useState } from 'react';
import { FormattedHTMLMessage, InjectedIntl, injectIntl } from 'react-intl';
import {
    ExtendedFieldValidationErrors,
    FieldValidationErrors,
    VerificationService,
} from '@sheerid/jslib';
import { ClassGroupComponent } from '../ClassGroup/ClassGroupComponent';
import { ClassNameComponent } from '../ClassName/ClassNameComponent';
import { ClassGroupChoice, ClassIDChoice } from '../../../lib/types/types';
import { TooltipComponent } from '../../Tooltip/TooltipComponent';

interface MajorProps {
    isErrored: boolean;
    intl: InjectedIntl;
    verificationService: VerificationService;
    onChange: any;
    value: ClassIDChoice;
}

export const Major = ({
    isErrored,
    intl,
    verificationService,
    onChange,
    value,
}: MajorProps) => {
    const fieldValidationErrors: FieldValidationErrors & ExtendedFieldValidationErrors = verificationService.fieldValidationErrors;
    const [majorGroup, setMajorGroup] = useState(undefined);

    return (
        <div className="sid-field">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-major">
                <div className="sid-field__label sid-field__label--required sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="myMajor"
                        defaultMessage="My Major"
                    />
                </div>
                <div className="sid-field__label-explanation">
                    <FormattedHTMLMessage
                        id="optionalExplanation"
                        defaultMessage="(optional)"
                    />
                </div>
            </label>
            <TooltipComponent
                fieldId='major'
                intl={intl}
                tooltipText={
                    intl.formatMessage({
                        id: 'major.tooltipText',
                        defaultMessage: 'Some of our partners offer additional discounts for students who provide information about their area of study. To qualify for these discounts you may provide your answers below.',
                    })
                }/>
            <div className='sid-major-inputs'>
                <ClassGroupComponent
                    value={majorGroup}
                    onChange={(choice: ClassGroupChoice) => {
                        setMajorGroup(choice);
                        onChange(undefined);
                    }}
                    isErrored={!!fieldValidationErrors.majorClassGroup}
                    placeholder={
                        intl.formatMessage({
                            id: 'areaOfStudy',
                            defaultMessage: 'Area of Study',
                        })
                    }
                    inputId="sid-major-class-group"
                    fieldId="majorClassGroup"
                />
                <ClassNameComponent
                    value={value}
                    onChange={(choice: ClassIDChoice) => onChange(choice) }
                    classGroup={majorGroup}
                    isErrored={!!fieldValidationErrors.major}
                    placeholder={
                        intl.formatMessage({
                            id: 'majorPlaceholder',
                            defaultMessage: 'Major',
                        })
                    }
                    fieldId="majorClassName"
                    inputId="sid-major-class-id"
                />
            </div>

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidMajor"
                            defaultMessage="Invalid major"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const MajorComponent = injectIntl(Major);
